import { Box, Button, Icon, Image, Img, Input, Link, ListItem, SimpleGrid, Text, UnorderedList, useColorModeValue } from "@chakra-ui/react";
import { AFFAIR_KINDS_ARR, GUARD_KINDS_ARR } from "components/appComponents";
import { useVVStore } from "components/store";
import { ArticleRightImage, CardContentHead1, CardContentHead2, CkaHirekLink, FecebookLink, PeticioLink, VizKoalicioLink, VizvCard, VizvCardAction, VizvCardContent, VizvCardHeader, VizvMainCol } from "components/vizvComponents";
import { GuardKindBox, GuardKindContainer } from "features/profile/Profile";
import { MdArrowDownward } from "react-icons/md";
import { NavLink, Outlet, useNavigate } from "react-router";
import { NYIL_BTN } from "theme";




export function WelcomeLinkArrow() {
    const color = useColorModeValue('#fff', '#000')
    return <Box display='flex' flexDir='row' alignItems='center' justifyContent='center' p={3}>
        <Icon fontSize='3xl' as={MdArrowDownward} color={color} />
    </Box>
}


export function WelcomeLayout() {
    return <>
        <Outlet />
    </>
}


export function Welcome1() {
    const isMobile = useVVStore(state => state.isMobile());
    return <VizvMainCol>
        <VizvCard isClosable>
            {!isMobile && true && <Box
                display='flex' justifyContent='center' alignItems='center'
                mb='-25px' ml='2em'
                alignSelf='flex-start'
                p='2em 1em'
            >
                <Image src='/logo/vizvedok_neg2_400.png' height='60px' />
            </Box>}


            <VizvCardHeader
                isMainLogo={true}
                fontSize={isMobile ? '3xl !important' : '6xl !important'}

            >A VÍZÜGY KÖZÖS ÜGY!</VizvCardHeader>

            <VizvCardContent display='flex' flexDir={isMobile ? 'column' : 'row'} justifyContent='space-between'>

                <Box maxWidth='35em'>
                    <ul className='ulbox'>
                        <li>Jó helyen jársz, ha aggódsz Magyarország <u>vezetékes</u> és <b>természetes vizeiért</b>!</li>
                        <li>Fotókkal és videókkal dokumentáltan <Link as={NavLink} to='/map' className='xx2'>térképen</Link> rögzítünk minden tudomásunkra jutott esetet.</li>
                        <li><Link as={NavLink} to='/welcome/legyel_te_is_vizvedo' className='xx2'>Csatlakozz</Link> Te is! Legyél VízVédő! Mutatjuk mit tehetsz!</li>
                        <li>Nézd meg <Link as={NavLink} to='/welcome/kik_vagyunk' className='xx2'>kik vagyunk</Link>, ismerkedj meg a <VizKoalicioLink /> tevékenységével!</li>
                    </ul>

                </Box>

                <Box position='relative' top='0px' display={isMobile?'none':'block'}>
                    <Img src='/images/figura1.png' height={260} />
                </Box>

            </VizvCardContent>
            <Box display='flex' flexDir='row' mb={3} mt='-1em'>
                <VizvCardAction protLev="any" to='/welcome/kik_vagyunk' >Kik vagyunk?</VizvCardAction>
            </Box>


        </VizvCard>
    </VizvMainCol>
}




export function WelcomeKikVagyunk() {
    const isMobile = useVVStore(state => state.isMobile());
    const isFull = useVVStore(state => state.isFull());
    return <VizvMainCol>
        <VizvCard>
            <VizvCardHeader>Kik vagyunk?</VizvCardHeader>
            <VizvCardContent display='flex'
                flexDir={isFull ? 'row' : 'column-reverse'}
                justifyContent='space-between'
                alignItems='center'
            >
                <Box maxW='35em'>
                    <ul className='ulbox'>
                        <li>A <VizKoalicioLink /> 2021 óta kongatja a vészharangot a kormány intézkedéseiből eredő veszteségek miatt <b>országos krízishelyzettel fenyegető</b> víziközmű-hálózat <u>végletesen leromlott</u> állapotával és felújításának szükségességével kapcsolatosan.</li>

                        <li><PeticioLink>Petíciót indítottunk</PeticioLink>, írd alá te is!

                            <UnorderedList ml='2em' py={1} fontStyle='italic'>
                                <li>„Elvárjuk, hogy legyen az országban <b>hosszú távon is biztonságos</b> és folyamatos víziközmű-szolgáltatás.”</li>
                                <li>„Magyarország állampolgáraiként kérjük, hogy a kormány gondoskodjon a <u>minőségi víziközmű-szolgáltatások</u> fenntartásához szükséges források biztosításáról.”</li>
                            </UnorderedList>

                        </li>
                        <li>
                            Kövesd a munkánkat!
                            <UnorderedList ml='2em' py={1} >
                                <li>Kövesd <FecebookLink>Facebook oldalunkat</FecebookLink>!</li>
                                <li>Figyeld a Víz Koalíció híreit a <CkaHirekLink>CKA oldalán</CkaHirekLink>!</li>
                            </UnorderedList>

                        </li>

                    </ul>
                </Box>
                {/*<ArticleRightImage src='/images/kik_vagyunk.jpg' width={400} />*/}
                <Box position='relative' top='0px'>
                    <Img src='/images/kikvagyunk.png' />
                </Box>

            </VizvCardContent>
            <Box display='flex' flexDir='row' mb={3}>
                <VizvCardAction protLev="any" to='/welcome/mit_csinalunk'>Mit csinálunk?</VizvCardAction>
            </Box>

        </VizvCard>
    </VizvMainCol>
}

export function WelcomeMitCsinalunk() {
    const isMobile = useVVStore(state => state.isMobile());
    const isFull = useVVStore(state => state.isFull());
    return <VizvMainCol>
        <VizvCard isClosable >
            <VizvCardHeader>Mit csinálunk?</VizvCardHeader>
            <VizvCardContent display='flex' flexDir={isFull ? 'row' : 'column'} justifyContent='space-between' alignItems='center' >
                <Box maxW='35em'>

                    <ul className='ulbox'>
                        <li>Figyelünk a <u>vezetékes</u> és <b>természetes vizeink</b> állapotára a településünkön.</li>
                        <li>Ha bármelyikkel kapcsolatosan problémát észlelünk, bejelentjük a helyi szolgáltatónak és <b>felhívjuk rá a lakosság figyelmét.</b></li>
                        <li>Fotóval, videóval <u>dokumentáljuk</u>, hogy mi történt, és feltöltjük a <Link as={NavLink} to='/map' className='xx2'>térképre</Link>.</li>
                        <li>Rögzítjük a probléma helyét, idejét és jellegét az országos adatbázisba.</li>
                        <li>Az adatbázisból készülő tanulmánnyal a <VizKoalicioLink /> munkáját segítjük.</li>
                    </ul>
                </Box>
                <Box position='relative' top='0px'>
                    <Img src='/ai/planning_cut2.png' width={420} />
                </Box>
                {/*<ArticleRightImage src='/images/csapat2.jpg' width={400} />*/}
            </VizvCardContent>
            <Box display='flex' flexDir='row' mb={3}>
                <VizvCardAction protLev="any" to='/welcome/legyel_te_is_vizvedo'>Legyél te is vízvédő</VizvCardAction>
            </Box>

        </VizvCard>
    </VizvMainCol>
}


export function WelcomeLegyTeIsVizvedo() {
    const isMobile = useVVStore(state => state.isMobile());
    const isFull = useVVStore(state => state.isFull());
    return <VizvMainCol>
        <VizvCard>
            <VizvCardHeader>Legyél te is vízvédő!</VizvCardHeader>
            <VizvCardContent display='flex'
                flexDir={isFull ? 'column' : 'column'}
                justifyContent='space-between'
                alignItems='center'
                gap={4}
            >
                <Box display='flex' flexDir={isMobile ? 'column' : 'row'} alignItems='center'>
                    <Box maxW='45em' pl={0}>
                        <CardContentHead2>Problémát észleltél a környezetedben?</CardContentHead2>



                        <UnorderedList className='ulboxx' ml='0em' mr={1} mt={0}>

                            <ListItem>Csőtörést? Dugulást? Vízminőség problémát?
                                <Link as={NavLink} to='/create' className='xx3' >Bejelentem</Link></ListItem>
                            <ListItem>Regisztrálj <Link as={NavLink} to='/profile' className='xx2' >e-mail címmel</Link> és csatlakozz a VízVédőkhöz!</ListItem>

                            <ListItem>Legyél {GUARD_KINDS_ARR.filter(gk => gk.key !== '00').map(g => g.name).join(', ')}!
                            </ListItem>
                            <ListItem>Helyezd el magad a <Link as={NavLink} to='/map' className='xx2'>térképen</Link>, hogy megtaláljanak a környékeden!
                            </ListItem>
                        </UnorderedList>


                        <CardContentHead1 my={8}>Segítsd a Víz Koalíció munkáját!</CardContentHead1>
                        <UnorderedList className='ulboxx' ml='0em' mr={1} mt={0}>
                            <ListItem>Írd alá és oszd meg <PeticioLink>petíciónkat</PeticioLink>!</ListItem>
                            <ListItem><Link as={NavLink} to='https://forms.gle/z5zZJjNfqUaWZi749' className="xx3" target='_blank'>Lépj be</Link> a Víz Koalícióba, legyél a tagunk vagy tagszervezetünk!</ListItem>
                            <ListItem><Link as={NavLink} to='/welcome/foundraising' className='xx2' >Támogasd</Link> a működésünket vagy egy projektünket!</ListItem>
                            <ListItem><Link href='mailto:vizkolacio@cka.hu' className="xx2">Legyél</Link> a Partnerünk <b>(akár csak egy projekt megvalósításában)</b>!</ListItem>
                            <ListItem><Link href='mailto:vizkolacio@cka.hu' className="xx2">Legyél</Link> az Önkéntesünk!</ListItem>
                        </UnorderedList>

                    </Box>
                    <Box position='relative' top='0px'>
                        <Img src='/ai/figura2.png' width={250} />
                    </Box>


                </Box>
                <Box display='flex' flexDir={isMobile ? 'column-reverse' : 'row'} alignItems='center'>
                    <Box position='relative' top='0px' display={isMobile ? 'none' : 'block'}>
                        <Img src='/ai/figura1.png' width={140} />
                    </Box>
                    <Box maxW='45em' pl={0}>
                        <CardContentHead2>Nézz körül az országban!</CardContentHead2>
                        <Box>
                            <ul>
                                <li><Link as={NavLink} to='/map' className='xx2'>Térképen</Link> gyűjtjük a vezetékes és természetes vizeinkkel kapcsolatos problémákat.</li>
                                <li>Az eseteket regisztráljuk és leírással, képpel, videóval dokumentáljuk.</li>
                                <li><Link as={NavLink} to='/group' className='xx2'>Nézz körül az országban</Link>, nézd meg milyen esetek fordultak elő a környékeden!</li>
                            </ul>
                        </Box>
                    </Box>
                </Box>


                {/*
                
                */}

            </VizvCardContent>
            <Box display='flex' flexDir='row' mb={3} mt='auto'>
                <VizvCardAction protLev="any" to='/group'>Megnézem</VizvCardAction>
            </Box>
        </VizvCard>
    </VizvMainCol >
}



export function Foundraising() {
    const nav = useNavigate();
    return <VizvMainCol>
        <VizvCard onClose={() => nav('/welcome/legyel_te_is_vizvedo')} >
            <VizvCardHeader>Támogass minket!</VizvCardHeader>
            <VizvCardContent>
                <UnorderedList>
                    <ListItem>Civil Kollégium Alapítvány:<br />
                        <br />
                        <Input value='MagNet Bank 16200106-11673947' />
                        <br /><br />
                    </ListItem>
                    <ListItem>
                        Közleménybe kérjük az alábbi szöveg feltüntetését: <br />“Víz Koalíció” vagy “Víz Koalíció (és a projekt címe)”
                    </ListItem>
                </UnorderedList>
                <br /><br /><br /><br /><br /><br />
            </VizvCardContent>

        </VizvCard>
    </VizvMainCol>
}

export function Impresszum() {
    const isMobile = useVVStore(state => state.isMobile());
    return <VizvMainCol>
        <VizvCard isClosable >
            <VizvCardHeader>Impresszum</VizvCardHeader>
            <VizvCardContent>
                <Box display='flex' flexDir={isMobile ? 'column' : 'row'} gap={5} justifyContent='flex-start' alignItems='center' >
                    <Box flex='0 1 33%'>A Víz Koalíció a <Link className="xx2" href='https://cka.hu/' target='_blank' color='#ffed6c !important' >Civil Kollégium Alapítvány</Link> közösségszervező programjában megvalósuló országos civil szerveződés, melyet civil szervezetek, önkormányzatok, szakértők alkotnak.</Box>
                    <UnorderedList flex='0 1 33%' alignSelf='center'>
                        <ListItem><FecebookLink>facebook.com/vizkoalicio</FecebookLink></ListItem>
                        <ListItem><Link className="xx2" href='https://www.instagram.com/vizkoalicio' target='_blank'>instagram.com/vizkoalicio</Link></ListItem>
                        <ListItem>Web: <VizKoalicioLink /> </ListItem>
                        <ListItem>Email: <Link className="xx2" href='mailto:vizkoalicio@cka.hu' target='_blank'>vizkoalicio@cka.hu</Link></ListItem>
                    </UnorderedList>
                    <Box flex='0 1 33%' m={4} display='flex' flexDir='column' gap={4} justifyContent='center' alignItems='center'>
                        <Link href='https://www.cka.hu/viz-koalicio/' target='_blank'><Img src='/logo/vizkoalicio_logo.png' width='270px' /></Link>
                        <Link href='https://www.cka.hu' target='_blank'><Img src='/logo/cka_logo_color_RGB_negativ.png' height='110px' /></Link>
                    </Box>

                </Box>

                <CardContentHead1>Támogatók:</CardContentHead1>
                A Vízvédők weboldalt a <Link className="xx2" href="https://kozosertekeink.hu/">Közös Értékeink Program</Link> támogatja, ami az <b>Európai Unió “Polgárok, egyenlőség, jogok
                    és értékek” (CERV)</b> programjának keretében valósul meg.
                <Box as='p' fontStyle='italic' mb={6} mt={3} fontSize='sm'>
                    “A projekt az Európai Unió “Polgárok, egyenlőség, jogok és értékek” (CERV) programjának
                    támogatásával valósul meg. Az Európai Bizottság támogatása nem jelenti a projektben megvalósított
                    tevékenységek tartalmának jóváhagyását, amely kizárólag az azt megvalósítók álláspontját tükrözi,
                    valamint a Bizottság nem tehető felelőssé ezen információk bárminemű felhasználásáért.”
                </Box>

                <Box display='flex' flexDir={isMobile ? 'column' : 'row'} gap={5} justifyContent='space-evenly' alignItems='center' >
                    <Link href='https://okotars.hu' target='_blank'><Img src='/logo/okotars.jpg' mx='3em' height='110px' /></Link>
                    <Link href='https://kofe.hu' target='_blank'><Img src='/logo/kofe.png' mx='3em' /></Link>
                    <Link href='https://autonomia.hu' target='_blank'><Img src='/logo/autonomia_logo_hu.png' mx='3em' /></Link>
                    <Link href='https://www.karpatokalapitvany.hu' target='_blank'><Img src='/logo/karp-logo-hu-uj.png' mx='3em' /></Link>
                    <Img src='/logo/eu.png' mx='3em' width='160px' />
                </Box>

                <Box display='flex' alignItems='center' justifyContent='center' fontWeight='bold' color='#fff' py='1em'>
                    © 2025 Vízvédők
                </Box>

            </VizvCardContent>

        </VizvCard>
    </VizvMainCol>
}
